import ManagementIntraction from "./managementIntraction";
export default ManagementIntraction;